import { Heading, Stack, Text } from "@chakra-ui/react";
import React from "react";

const HeadingSection = ({ title, desc }) => {
  return (
    <Stack
      py={{ base: "10", md: "20" }}
      lineHeight="1"
      spacing="5"
      px={{ base: "5", md: "10", lg: "20" }}
      className="blend"
    >
      <Heading as="h6" size="xs" letterSpacing="4px">
        {title}
      </Heading>
      <Text
        fontSize={{ base: "2xl", md: "4xl", lg: "4xl" }}
        fontWeight="bold"
        lineHeight="1.2"
      >
        {desc}
      </Text>
    </Stack>
  );
};

export default HeadingSection;
